/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ArtifactsControllerFindOneQueryResponse, ArtifactsControllerFindOnePathParams, ArtifactsControllerFindOneQueryParams, ArtifactsControllerFindOne400, ArtifactsControllerFindOne401, ArtifactsControllerFindOne403, ArtifactsControllerFindOne404 } from "../../models/documentArtifactsController/ArtifactsControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { artifactsControllerFindOne } from "../../clients/document-artifactsService/artifactsControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const artifactsControllerFindOneQueryKey = (documentId: ArtifactsControllerFindOnePathParams["documentId"], renditionId: ArtifactsControllerFindOnePathParams["renditionId"], artifactId: ArtifactsControllerFindOnePathParams["artifactId"], params: ArtifactsControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/documents/:documentId/renditions/:renditionId/artifacts/:artifactId',
  params: {
    documentId: documentId,
    renditionId: renditionId,
    artifactId: artifactId
  }
}, ...(params ? [params] : [])] as const;
export type ArtifactsControllerFindOneQueryKey = ReturnType<typeof artifactsControllerFindOneQueryKey>;
export function artifactsControllerFindOneQueryOptions(documentId: ArtifactsControllerFindOnePathParams["documentId"], renditionId: ArtifactsControllerFindOnePathParams["renditionId"], artifactId: ArtifactsControllerFindOnePathParams["artifactId"], params?: ArtifactsControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = artifactsControllerFindOneQueryKey(documentId, renditionId, artifactId, params);
  return queryOptions<ArtifactsControllerFindOneQueryResponse, ResponseErrorConfig<ArtifactsControllerFindOne400 | ArtifactsControllerFindOne401 | ArtifactsControllerFindOne403 | ArtifactsControllerFindOne404>, ArtifactsControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!(documentId && renditionId && artifactId),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return artifactsControllerFindOne(documentId, renditionId, artifactId, params, config);
    }
  });
}

/**
 * @description Returns a specific artifact by its ID
 * @summary Get a specific artifact
 * {@link /api/v1/documents/:documentId/renditions/:renditionId/artifacts/:artifactId}
 */
export function useArtifactsControllerFindOne<TData = ArtifactsControllerFindOneQueryResponse, TQueryData = ArtifactsControllerFindOneQueryResponse, TQueryKey extends QueryKey = ArtifactsControllerFindOneQueryKey>(documentId: ArtifactsControllerFindOnePathParams["documentId"], renditionId: ArtifactsControllerFindOnePathParams["renditionId"], artifactId: ArtifactsControllerFindOnePathParams["artifactId"], params?: ArtifactsControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<ArtifactsControllerFindOneQueryResponse, ResponseErrorConfig<ArtifactsControllerFindOne400 | ArtifactsControllerFindOne401 | ArtifactsControllerFindOne403 | ArtifactsControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? artifactsControllerFindOneQueryKey(documentId, renditionId, artifactId, params);
  const query = useQuery({
    ...artifactsControllerFindOneQueryOptions(documentId, renditionId, artifactId, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ArtifactsControllerFindOne400 | ArtifactsControllerFindOne401 | ArtifactsControllerFindOne403 | ArtifactsControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}